import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { Location } from '@angular/common';

import { CuttingTableValidator } from '../../cutting_table.validator';
import { AuxFunction } from '../../../../_helpers/aux.function';
import { FormValidator } from '../../../../_helpers/form.validator';
import { Translation } from '../../../../_languages/translations';
import { CuttingTable } from '../../../../_models/cutting_table';
import { Globals } from '../../../../_globals/globals';

@Component({
  selector: 'app-cutting_table-edit',
  templateUrl: './cutting_table-edit.component.html'
})
export class CuttingTableEditComponent implements OnInit {

  // Para el control del diccionario de traducción.
  tr: {};
  auxFunction: AuxFunction;

  title: string;
  subtitle: string;

  cutting_tableForm: FormGroup;

  actionModal: boolean;
  alertModal: boolean;
  infoModal: boolean;

  actionInfo: string;
  alertInfo = '';
  infoInfo: string;

  // Variable para el control de las validaciones del formulario y sus mensajes.
  formValidator: FormValidator;

  current_user_enviroment: string;
  cncFamilyOptions: string[];
  originOptions: any[];
  levelOptions: any[];
  axisOptions: string[];


  @Input() cuttingTable: CuttingTable;
  @Input() cuttingTableTypes: CuttingTable[];
  @Output() updateCuttingTable = new EventEmitter<CuttingTable>();
  @Output() showInfoModal = new EventEmitter<{ value: boolean, info: string, link: string, skin: string }>();

  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    private _location: Location,
    private globals: Globals,
    public trans: Translation
  ) {
    this.formValidator = new FormValidator();
  }

  // convenience getter for easy access to form fields
  get f() { return this.cutting_tableForm.controls; }

  ngOnInit() {

    this.tr = this.trans.vocabulary;
    this.auxFunction = new AuxFunction();

    this.current_user_enviroment = localStorage.getItem('enviroment');
    console.log(' -> current_user_enviroment: ' + this.current_user_enviroment);

    this.cncFamilyOptions = this.globals.getCncMasterFamilies(localStorage.getItem('permissions'));
    this.originOptions = [
      { value: 1, label: 'Arriba / Izquierda' },
      { value: 2, label: 'Abajo / Izquierda' },
      { value: 3, label: 'Abajo / Derecha' },
      { value: 4, label: 'Arriba / Derecha' }
    ];
    this.levelOptions = [
      { value: 20, label: '∞' },
      { value: 6, label: '6' },
      { value: 5, label: '5' },
      { value: 4, label: '4' },
      { value: 3, label: '3' },
      { value: 2, label: '2' },
      { value: 1, label: '1' }
    ];
    this.axisOptions = ['X', 'Y'];

    const masterData = this.parseMasterData(this.cuttingTable ? this.cuttingTable.param4 : null);
    const defaultType = this.getDefaultTypeId();

    // Los procesos siempre van a tener género 1 y tipo 3.
    this.cutting_tableForm = this.formBuilder.group({
      id:  this.cuttingTable.id,
      name: [this.cuttingTable.name, Validators.required],
      type_id: [this.cuttingTable.type_id ? this.cuttingTable.type_id : defaultType, Validators.required],
      cnc_family: [this.cncFamilyOptions.indexOf(masterData.cnc_family) !== -1 ? masterData.cnc_family : 'V40', Validators.required],
      sheet_width: [masterData.sheet_width, Validators.required],
      sheet_height: [masterData.sheet_height, Validators.required],
      origin: [masterData.origin, Validators.required],
      disband_l: [masterData.disband_l, Validators.required],
      disband_b: [masterData.disband_b, Validators.required],
      disband_r: [masterData.disband_r, Validators.required],
      disband_t: [masterData.disband_t, Validators.required],
      max_diecutting: [masterData.max_diecutting, Validators.required],
      level: [masterData.level, Validators.required],
      axis: [masterData.axis, Validators.required],
      sheet_load_unload_min: [masterData.sheet_load_unload_min, Validators.required],
      desc: this.cuttingTable.desc,
      path: this.cuttingTable.path,
      enviroment: this.current_user_enviroment,
      param1: this.cuttingTable.param1,
      param2: this.cuttingTable.param2,
      param3: this.cuttingTable.param3,
      param4: this.cuttingTable.param4,
      order: this.cuttingTable.order,
      active: this.cuttingTable.active
    });

    // Asignamos los mensajes de error asociados a las validaciones que vamos a usar en el formulario.
    this.formValidator.setTemplateMessages(CuttingTableValidator.templateMessages);

    this.title = this.tr['cuttingTableTitle'];
    this.subtitle = this.tr['cuttingTableEditSubtitle'];

    this.actionInfo = this.tr['modalCuttingTableEditInfo'];

    this.infoInfo = this.tr['modalOkInfo'];


    // Se crean las subscripciones para el control de los campos del formulario.
    this.formValidator.subscribeFormGroup(this.cutting_tableForm);

  } // End function OnInit

  saveCuttingTable(): void {

    // Nos aseguramos que el campo "entorno" de la mesa coincida con el entorno asociado al usuario.
    this.cutting_tableForm.controls.enviroment.setValue(this.current_user_enviroment);

    const masterData = {
      cnc_family: this.cutting_tableForm.controls.cnc_family.value,
      sheet_width: Number(this.cutting_tableForm.controls.sheet_width.value || 0),
      sheet_height: Number(this.cutting_tableForm.controls.sheet_height.value || 0),
      origin: Number(this.cutting_tableForm.controls.origin.value || 1),
      disband_l: Number(this.cutting_tableForm.controls.disband_l.value || 0),
      disband_b: Number(this.cutting_tableForm.controls.disband_b.value || 0),
      disband_r: Number(this.cutting_tableForm.controls.disband_r.value || 0),
      disband_t: Number(this.cutting_tableForm.controls.disband_t.value || 0),
      max_diecutting: Number(this.cutting_tableForm.controls.max_diecutting.value || 0),
      level: Number(this.cutting_tableForm.controls.level.value || 20),
      axis: this.cutting_tableForm.controls.axis.value ? this.cutting_tableForm.controls.axis.value.toString() : 'X',
      sheet_load_unload_min: Number(this.cutting_tableForm.controls.sheet_load_unload_min.value || 0)
    };

    const param4Txt = [
      'cnc_family=' + masterData.cnc_family,
      'sheet_width=' + masterData.sheet_width,
      'sheet_height=' + masterData.sheet_height,
      'origin=' + masterData.origin,
      'disband_l=' + masterData.disband_l,
      'disband_b=' + masterData.disband_b,
      'disband_r=' + masterData.disband_r,
      'disband_t=' + masterData.disband_t,
      'max_diecutting=' + masterData.max_diecutting,
      'level=' + masterData.level,
      'axis=' + masterData.axis,
      'sheet_load_unload_min=' + masterData.sheet_load_unload_min
    ].join(';');
    this.cutting_tableForm.controls.param4.setValue(param4Txt);
    this.cutting_tableForm.controls.param1.setValue(String(masterData.origin));
    this.cutting_tableForm.controls.param2.setValue(String(masterData.max_diecutting));
    this.cutting_tableForm.controls.param3.setValue(String(masterData.level));
    this.cutting_tableForm.controls.desc.setValue('CNC ' + masterData.cnc_family + ' | ' + masterData.sheet_width + 'x' + masterData.sheet_height);
    if (!this.cutting_tableForm.controls.path.value) {
      this.cutting_tableForm.controls.path.setValue('MESA:' + this.cutting_tableForm.controls.name.value);
    }

    // NOTA: Se copian los cambios sobre la obra inicial.
    const p = { ...this.cuttingTable, ...this.cutting_tableForm.value };

    this.updateCuttingTable.emit(p);

  } // End function saveCuttingTable

  changeUser(event: any): void {

    console.log('---> Cambiando Usuario:');
    console.log(event);

  } // End function changeUser

  // ------------------------------------
  //    VALIDACIÓN FINAL DEL FORMULARIO
  // ------------------------------------

  validateCuttingTable(): void {

    // Se realizan las comprobaciones pertinentes para confirmar que los campos del formulario son correctos.

    if (this.cutting_tableForm.valid) {
      console.log('-------> Formulario cutting_tableForm correcto.');

      if (this.cutting_tableForm.controls.name.value === '' && this.cutting_tableForm.controls.name.value === undefined) {
        this.alertInfo += this.tr['alertCuttingTableName'];
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      } else {
        this.showActionModal(true);
      }

    } else {
      console.log('-------> Formulario cutting_tableForm NO válido:');
      console.log(this.cutting_tableForm);

      this.alertInfo += this.tr['alertCuttingTableForm'];
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      this.alertInfo = '';
    }
  } // End function validateCuttingTable

  // ------- Función de regreso
  back(): void {
    // this._location.back();
    this.router.navigate(['/cutting_table']);
  } // End function back

  // -----------------------------------------------
  //  FUNCIONES PARA EL CONTROL DE VENTANAS MODALES
  // -----------------------------------------------

  showActionModal(value: boolean) {
    this.actionModal = value;

  } // End function showActionModal

  confirmActionModal() {

    console.log('--> - -> Confirmada acción del modal.');

    this.saveCuttingTable();

    this.showActionModal(false);
  } // End function confirmActionModal

  private getDefaultTypeId(): number {
    if (!this.cuttingTableTypes || this.cuttingTableTypes.length < 1) return 1;
    const first = this.cuttingTableTypes[0];
    return first && first.id ? Number(first.id) : 1;
  }

  private parseMasterData(param4In: any): any {
    const defaults = {
      cnc_family: 'V40',
      sheet_width: 6000,
      sheet_height: 3210,
      origin: 1,
      disband_l: 0,
      disband_b: 0,
      disband_r: 0,
      disband_t: 0,
      max_diecutting: 2500,
      level: 20,
      axis: 'X',
      sheet_load_unload_min: 0
    };

    try {
      const parsed = this.parseMasterParam4(param4In);
      const legacy = this.getLegacyFallback();
      const persistedLoad = this.toNumber(
        this.cuttingTable && this.cuttingTable['sheet_load_unload_min'] !== undefined
          ? this.cuttingTable['sheet_load_unload_min']
          : null
      );
      if (!parsed || typeof parsed !== 'object') return legacy;
      const width = this.getNumberValue(parsed, ['sheet_width', 'width', 'ancho', 'f_width'], legacy.sheet_width);
      const height = this.getNumberValue(parsed, ['sheet_height', 'height', 'alto', 'f_height'], legacy.sheet_height);
      const origin = this.getNumberValue(parsed, ['origin', 'f_origin'], legacy.origin);
      const disbandL = this.getNumberValue(parsed, ['disband_l', 'f_disband_l'], legacy.disband_l);
      const disbandB = this.getNumberValue(parsed, ['disband_b', 'f_disband_b'], legacy.disband_b);
      const disbandR = this.getNumberValue(parsed, ['disband_r', 'f_disband_r'], legacy.disband_r);
      const disbandT = this.getNumberValue(parsed, ['disband_t', 'f_disband_t'], legacy.disband_t);
      const maxTrav = this.getNumberValue(parsed, ['max_diecutting', 'maxtrav', 'max_trav', 'max_travera', 'f_max_diecutting'], legacy.max_diecutting);
      const level = this.getNumberValue(parsed, ['level', 'f_level'], legacy.level);
      const axis = this.getStringValue(parsed, ['axis', 'f_axis'], legacy.axis);
      const loadUnload = this.getNumberValue(
        parsed,
        ['sheet_load_unload_min', 'load_unload_min', 'tiempo_carga_descarga_hoja'],
        !isNaN(persistedLoad) && persistedLoad >= 0 ? persistedLoad : legacy.sheet_load_unload_min
      );
      const parsedCnc = this.getStringValue(parsed, ['cnc_family', 'cnc', 'export', 'export_type'], legacy.cnc_family);
      const descCnc = this.extractCncFromText(this.cuttingTable && this.cuttingTable.desc ? this.cuttingTable.desc.toString() : '');

      return {
        cnc_family: descCnc ? descCnc : parsedCnc,
        sheet_width: width > 0 ? width : legacy.sheet_width,
        sheet_height: height > 0 ? height : legacy.sheet_height,
        origin: origin >= 1 && origin <= 4 ? origin : legacy.origin,
        disband_l: disbandL >= 0 ? disbandL : legacy.disband_l,
        disband_b: disbandB >= 0 ? disbandB : legacy.disband_b,
        disband_r: disbandR >= 0 ? disbandR : legacy.disband_r,
        disband_t: disbandT >= 0 ? disbandT : legacy.disband_t,
        max_diecutting: maxTrav > 0 ? maxTrav : legacy.max_diecutting,
        level: level > 0 ? level : legacy.level,
        axis: axis === 'Y' ? 'Y' : 'X',
        sheet_load_unload_min: loadUnload >= 0 ? loadUnload : legacy.sheet_load_unload_min
      };
    } catch (error) {
      return this.getLegacyFallback();
    }
  }

  private parseMasterParam4(param4In: any): any {
    if (param4In === undefined || param4In === null) return null;
    if (typeof param4In === 'object') return param4In;
    const txt = String(param4In).trim();
    if (txt === '') return null;

    const parseJsonSafe = (txtIn: string) => {
      try { return JSON.parse(txtIn); } catch (error) { return null; }
    };

    let parsed = parseJsonSafe(txt);
    if (parsed && typeof parsed === 'string') {
      const nested = parseJsonSafe(parsed);
      if (nested) parsed = nested;
    }
    if (parsed && typeof parsed === 'object') {
      return parsed.masterData && typeof parsed.masterData === 'object' ? parsed.masterData : parsed;
    }

    let txtAux = txt;
    if ((txtAux.startsWith('"') && txtAux.endsWith('"')) || (txtAux.startsWith("'") && txtAux.endsWith("'"))) {
      txtAux = txtAux.substring(1, txtAux.length - 1);
      txtAux = txtAux.replace(/\\"/g, '"');
      txtAux = txtAux.replace(/\\'/g, "'");
      const parsedWrapped = parseJsonSafe(txtAux);
      if (parsedWrapped && typeof parsedWrapped === 'object') return parsedWrapped;
    }

    const firstBrace = txtAux.indexOf('{');
    const lastBrace = txtAux.lastIndexOf('}');
    if (firstBrace >= 0 && lastBrace > firstBrace) {
      const objTxt = txtAux.substring(firstBrace, lastBrace + 1);
      const parsedObj = parseJsonSafe(objTxt);
      if (parsedObj && typeof parsedObj === 'object') return parsedObj;
    }

    const kvObj = this.parseKeyValueMasterData(txtAux);
    if (kvObj) return kvObj;

    const parts = txtAux.split(',').map((p) => p.trim());
    if (parts.length >= 6) {
      return {
        sheet_width: this.toNumber(parts[0]),
        sheet_height: this.toNumber(parts[1]),
        max_diecutting: this.toNumber(parts[2]),
        level: this.toNumber(parts[3]),
        axis: parts[4],
        origin: this.toNumber(parts[5])
      };
    }
    return null;
  }

  private getNumberValue(objIn: any, keysIn: string[], defaultIn: number): number {
    for (let i = 0; i < keysIn.length; i++) {
      const key = keysIn[i];
      if (objIn[key] !== undefined && objIn[key] !== null && objIn[key] !== '') {
        const num = this.toNumber(objIn[key]);
        if (!isNaN(num)) return num;
      }
    }
    return defaultIn;
  }

  private getStringValue(objIn: any, keysIn: string[], defaultIn: string): string {
    for (let i = 0; i < keysIn.length; i++) {
      const key = keysIn[i];
      if (objIn[key] !== undefined && objIn[key] !== null && objIn[key] !== '') {
        return String(objIn[key]);
      }
    }
    return defaultIn;
  }

  private toNumber(valueIn: any): number {
    if (valueIn === undefined || valueIn === null || valueIn === '') return NaN;
    if (typeof valueIn === 'number') return valueIn;
    let txt = String(valueIn).trim();
    if (txt === '') return NaN;
    txt = txt.replace(/\s/g, '');
    if (txt.indexOf(',') >= 0 && txt.indexOf('.') < 0) txt = txt.replace(',', '.');
    return Number(txt);
  }

  private parseKeyValueMasterData(txtIn: string): any {
    const separators = txtIn.indexOf(';') >= 0 ? ';' : (txtIn.indexOf('|') >= 0 ? '|' : ',');
    const tokens = txtIn.split(separators).map((t) => t.trim()).filter((t) => t !== '');
    if (tokens.length < 2) return null;
    const out = {};
    let matched = 0;
    tokens.forEach((token) => {
      const idx = token.indexOf('=');
      if (idx < 1) return;
      const key = token.substring(0, idx).trim().toLowerCase();
      const value = token.substring(idx + 1).trim();
      if (key === 'cnc' || key === 'cnc_family' || key === 'export') { out['cnc_family'] = value; matched++; }
      if (key === 'sheet_width' || key === 'width' || key === 'ancho') { out['sheet_width'] = this.toNumber(value); matched++; }
      if (key === 'sheet_height' || key === 'height' || key === 'alto') { out['sheet_height'] = this.toNumber(value); matched++; }
      if (key === 'origin' || key === 'f_origin') { out['origin'] = this.toNumber(value); matched++; }
      if (key === 'max_diecutting' || key === 'maxtrav' || key === 'max_trav') { out['max_diecutting'] = this.toNumber(value); matched++; }
      if (key === 'level' || key === 'f_level') { out['level'] = this.toNumber(value); matched++; }
      if (key === 'axis' || key === 'f_axis') { out['axis'] = value; matched++; }
      if (key === 'sheet_load_unload_min' || key === 'load_unload_min' || key === 'tiempo_carga_descarga_hoja') { out['sheet_load_unload_min'] = this.toNumber(value); matched++; }
      if (key === 'disband_l' || key === 'f_disband_l') { out['disband_l'] = this.toNumber(value); matched++; }
      if (key === 'disband_b' || key === 'f_disband_b') { out['disband_b'] = this.toNumber(value); matched++; }
      if (key === 'disband_r' || key === 'f_disband_r') { out['disband_r'] = this.toNumber(value); matched++; }
      if (key === 'disband_t' || key === 'f_disband_t') { out['disband_t'] = this.toNumber(value); matched++; }
    });
    if (matched < 2) return null;
    return out;
  }

  private getLegacyFallback(): any {
    const defaults = {
      cnc_family: 'V40',
      sheet_width: 6000,
      sheet_height: 3210,
      origin: 1,
      disband_l: 0,
      disband_b: 0,
      disband_r: 0,
      disband_t: 0,
      max_diecutting: 2500,
      level: 20,
      axis: 'X',
      sheet_load_unload_min: 0
    };
    const descTxt = this.cuttingTable && this.cuttingTable.desc ? this.cuttingTable.desc.toString() : '';
    const descCnc = this.extractCncFromText(descTxt);
    const m = descTxt.match(/([0-9]{3,5})\s*[xX]\s*([0-9]{3,5})/);
    if (m && m[1] && m[2]) {
      defaults.sheet_width = this.toNumber(m[1]);
      defaults.sheet_height = this.toNumber(m[2]);
    }
    if (descCnc) {
      defaults.cnc_family = descCnc;
    }
    if (this.cuttingTable && this.cuttingTable.path) {
      const p = this.cuttingTable.path.toString();
      const cncMatch = p.match(/(V40|LSW|LIOPT|OTD|BTR|ELO|TEC)/i);
      if (!defaults.cnc_family || defaults.cnc_family === 'V40') {
        if (cncMatch && cncMatch[1]) defaults.cnc_family = cncMatch[1].toUpperCase();
      }
    }
    const p1 = this.toNumber(this.cuttingTable && this.cuttingTable.param1 !== undefined ? this.cuttingTable.param1 : null);
    const p2 = this.toNumber(this.cuttingTable && this.cuttingTable.param2 !== undefined ? this.cuttingTable.param2 : null);
    const p3 = this.toNumber(this.cuttingTable && this.cuttingTable.param3 !== undefined ? this.cuttingTable.param3 : null);
    const pLoad = this.toNumber(this.cuttingTable && this.cuttingTable['sheet_load_unload_min'] !== undefined ? this.cuttingTable['sheet_load_unload_min'] : null);
    const pDisL = this.toNumber(this.cuttingTable && this.cuttingTable['disband_l'] !== undefined ? this.cuttingTable['disband_l'] : null);
    const pDisB = this.toNumber(this.cuttingTable && this.cuttingTable['disband_b'] !== undefined ? this.cuttingTable['disband_b'] : null);
    const pDisR = this.toNumber(this.cuttingTable && this.cuttingTable['disband_r'] !== undefined ? this.cuttingTable['disband_r'] : null);
    const pDisT = this.toNumber(this.cuttingTable && this.cuttingTable['disband_t'] !== undefined ? this.cuttingTable['disband_t'] : null);
    if (!isNaN(p1) && p1 >= 1 && p1 <= 4) defaults.origin = p1;
    if (!isNaN(p2) && p2 > 0) defaults.max_diecutting = p2;
    if (!isNaN(p3) && p3 > 0) defaults.level = p3;
    if (!isNaN(pLoad) && pLoad >= 0) defaults.sheet_load_unload_min = pLoad;
    if (!isNaN(pDisL) && pDisL >= 0) defaults.disband_l = pDisL;
    if (!isNaN(pDisB) && pDisB >= 0) defaults.disband_b = pDisB;
    if (!isNaN(pDisR) && pDisR >= 0) defaults.disband_r = pDisR;
    if (!isNaN(pDisT) && pDisT >= 0) defaults.disband_t = pDisT;
    return defaults;
  }

  private extractCncFromText(txtIn: string): string {
    if (!txtIn) return '';
    const cncMatch = txtIn.match(/(?:CNC\s*)?(V40|LSW|LIOPT|OTD|BTR|ELO|TEC)/i);
    return cncMatch && cncMatch[1] ? cncMatch[1].toUpperCase() : '';
  }

} // End Class CuttingTableEditComponent
